document.addEventListener('DOMContentLoaded', function () {
    const addToCartForms = document.querySelectorAll('.add-to-cart-form');
    const closeButtons = document.querySelectorAll('.close-popup');
    let selectedForm = null;
    let isClickedOnce = false;
    let currentAddToCartButton = null;
    let currentPopup = null;


    addToCartForms.forEach(function (form) {
        const addToCartButton = form.querySelector('.add-to-cart-button');

        addToCartButton.addEventListener('click', function (event) {
            const cardId = this.dataset.cardId;
            const productPopup = document.querySelector(`#product-popup[data-card-id='${cardId}']`);
            const sellingPlanInput = productPopup.parentElement.querySelector(`#selling_plan_field_${cardId}`);

            if (!isClickedOnce || currentAddToCartButton !== addToCartButton) {
                event.preventDefault();
                hidePopup();

                if (currentAddToCartButton) {
                    currentAddToCartButton.style.backgroundColor = '';
                    currentAddToCartButton.style.border = '';
                    currentAddToCartButton.classList.remove('first-click');
                }

                addToCartButton.style.backgroundColor = '#007849';
                addToCartButton.style.border = '1px solid #007849';
                addToCartButton.classList.add('first-click');
                isClickedOnce = true;
                selectedForm = form;
                currentAddToCartButton = addToCartButton;
                currentPopup = productPopup;
                showPopup(productPopup, cardId, form);
            } else {
                addToCartButton.style.backgroundColor = '';
                addToCartButton.style.border = '';
                addToCartButton.classList.remove('first-click');
                isClickedOnce = false;

                const formData = new FormData(selectedForm);
                if (productPopup.querySelector(`#rc_purchase_type_autodeliver_${cardId}`).checked) {
                    formData.append('selling_plan', sellingPlanInput.value);
                }

                fetch('/cart/add.js', {
                    method: 'POST',
                    body: formData,
                    headers: {
                        'Accept': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                })
                    .then(response => response.json())
                    .then(data => {
                        console.log("Producto agregado al carrito:", data);
                    })
                    .catch(error => {
                        console.error("Error al agregar al carrito:", error);
                    });
            }
        });
    });

    closeButtons.forEach(function (closeButton) {
        closeButton.addEventListener('click', function () {
            hidePopup();
        });
    });

    function showPopup(productPopup, cardId, form) {
        if (currentPopup) {
            currentPopup.style.display = 'none';
        }
        productPopup.style.display = 'flex';
        document.addEventListener('click', outsideClickListener);

        const radioButtons = productPopup.querySelectorAll(`[name="purchase_type_${cardId}"]`);
        radioButtons.forEach(function (radio) {
            radio.addEventListener('change', function () {
                if (radio.id === `rc_purchase_type_onetime_${cardId}` && radio.checked) {
                    productPopup.querySelector('.button3-test').style.backgroundColor = '#f4f8f5';
                    productPopup.querySelector('.button3-test').style.borderColor = '#007849';
                    productPopup.querySelector('.rc_purchase_type__onetime__text.test').style.color = '#007849';
                    productPopup.querySelector('.container-packs-d.home').style.display = 'flex';

                    productPopup.querySelector('.button2-test').style.backgroundColor = '#ffffff';
                    productPopup.querySelector('.button2-test').style.borderColor = '#BCBCBC';
                    productPopup.querySelector('.abtest-1.test').style.color = '#1A1A1A';
                    productPopup.querySelector('.ul-value-props-test').style.display = 'none';

                    updateQuantityBasedOnSelectedPack(productPopup, cardId, form);
                    disableSellingPlans(productPopup);
                } else if (radio.id === `rc_purchase_type_autodeliver_${cardId}` && radio.checked) {
                    productPopup.querySelector('.button2-test').style.backgroundColor = '#f4f8f5';
                    productPopup.querySelector('.button2-test').style.borderColor = '#007849';
                    productPopup.querySelector('.abtest-1.test').style.color = '#007849';
                    productPopup.querySelector('.value-props__toggleSelling.test').style.display = 'block';
                    productPopup.querySelector('.ul-value-props-test').style.display = 'block';

                    productPopup.querySelector('.button3-test').style.backgroundColor = '#ffffff';
                    productPopup.querySelector('.button3-test').style.borderColor = '#BCBCBC';
                    productPopup.querySelector('.rc_purchase_type__onetime__text.test').style.color = '#1A1A1A';
                    productPopup.querySelector('.container-packs-d.home').style.display = 'none';

                    const quantityField = productPopup.parentElement.querySelector(`#quantity-field-${cardId}`);
                    quantityField.value = 1;
                    enableSellingPlans(productPopup);
                }
            });
        });
    }

    function hidePopup() {
        if (currentPopup) {
            currentPopup.style.display = 'none';
            document.removeEventListener('click', outsideClickListener);
        }
    }

    function outsideClickListener(event) {
        if (currentPopup && !currentPopup.contains(event.target) && !currentAddToCartButton.contains(event.target)) {
            hidePopup();
            if (currentAddToCartButton) {
                currentAddToCartButton.style.backgroundColor = '';
                currentAddToCartButton.style.border = '';
                currentAddToCartButton.classList.remove('first-click');
            }
        }
    }

    function updateQuantityBasedOnSelectedPack(productPopup, cardId, form) {
        var selectedPack = productPopup.querySelector('.container-packs-d.home .selected-d');
        const quantityField = productPopup.parentElement.querySelector(`#quantity-field-${cardId}`);
        if (selectedPack && quantityField) {
            quantityField.value = selectedPack.getAttribute('data-quantity');
        }
    }

    function disableSellingPlans(productPopup) {
        productPopup.parentElement.querySelectorAll('[name="selling_plan"]').forEach((item) => (item.disabled = true));
    }

    function enableSellingPlans(productPopup) {
        productPopup.parentElement.querySelectorAll('[name="selling_plan"]').forEach((item) => (item.disabled = false));
    }


    const packOptions = document.querySelectorAll('.container-packs-d.home .option-d');

    packOptions.forEach(function (option) {
        option.addEventListener('click', function () {
            const cardId = option.closest('#product-popup').dataset.cardId;
            var selectedOption = document.querySelector(`#product-popup[data-card-id='${cardId}'] .container-packs-d.home .selected-d`);
            const quantityField = option.closest(`#product-popup[data-card-id='${cardId}']`).parentElement.querySelector(`#quantity-field-${cardId}`);
            if (selectedOption) {
                selectedOption.classList.remove('selected-d');
            }
            option.classList.add('selected-d');

            var quantity = option.getAttribute('data-quantity');
            if (quantityField) {
                quantityField.value = quantity;
            }
        });
    });
});
